import React, { Suspense } from 'react';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { client as AfterSalesClient } from '@sunwisesoftware/client-aftersales-js';
import { client as BotyClient } from '@sunwisesoftware/client-boty-js';
import { client as WiseClient } from '@sunwisesoftware/client-wise-js';
import { client as ZapClient } from '@sunwisesoftware/client-zap-js';
import { ConnectedRouter } from 'connected-react-router';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';
import App from './App';
import './i18n';
import * as serviceWorker from './serviceWorker';
import configureStore, { history } from './store';
import { initAllThirdParty } from './thirdParty';

Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    appVersion: `${import.meta.env.VITE_VERSION}`,
    enabledReleaseStages: ['test', 'staging', 'prod'],
    plugins: [new BugsnagPluginReact()],
    releaseStage: import.meta.env.VITE_ENV,
});

initAllThirdParty();

AfterSalesClient.setConfig({
    auth: () => localStorage.getItem('token'),
    baseURL: import.meta.env.VITE_AFTER_SALES_API_URL,
    throwOnError: true,
});

BotyClient.setConfig({
    auth: () => localStorage.getItem('token'),
    baseURL: import.meta.env.VITE_BOTY_API_URL,
    throwOnError: true,
});

WiseClient.setConfig({
    auth: () => localStorage.getItem('token'),
    baseURL: import.meta.env.VITE_WISE_API_URL,
    throwOnError: true,
});

ZapClient.setConfig({
    auth: () => localStorage.getItem('zap-token'),
    baseURL: import.meta.env.VITE_ZAP_API_URL,
    throwOnError: true,
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ErrorBoundary>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Suspense fallback={null}>
                    <App />
                </Suspense>
            </ConnectedRouter>
        </Provider>
    </ErrorBoundary>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
